// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__33Lfs","box":"WorkspacesBox_box__1CwYn","node":"WorkspacesBox_node__HWmp_"};